export default "__VITE_ASSET__b7BKLVZh__"